/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroCreditoSeguro.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function EmprestimoGarantiaCarroCreditoSeguro() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-credito-seguro">
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/emprestimo-garantia-carro/img-credito-seguro.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/emprestimo-garantia-carro/img-credito-seguro.png"
                  />
                  <img
                    src="assets/emprestimo-garantia-carro/img-credito-seguro.png"
                    alt="Jovem realizando simulações de empréstimo com garantia no Santander."
                    className="credito-seguro-img"
                    width="288"
                    height="300"
                  />
                </picture>
              )}
              {width > 992 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/emprestimo-garantia-carro/img-credito-seguro-desk.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/emprestimo-garantia-carro/img-credito-seguro-desk.png"
                  />
                  <img
                    src="assets/emprestimo-garantia-carro/img-credito-seguro-desk.png"
                    alt="Jovem realizando simulações de empréstimo com garantia no Santander."
                    className="credito-seguro-img"
                    width="525"
                    height="623"
                  />
                </picture>
              )}
            </>
          )}
          <div className="credito-seguro-conteudo">
            <h3 className="credito-seguro-titulo">O crédito seguro que você procura</h3>
            <p className="credito-seguro-texto">
              Transforme seu carro em uma solução financeira inteligente e segura para virar a chave
              dos seus planos. Com o nosso <b>Empréstimo com Garantia de Veículo</b>, você pode
              realizar os seus sonhos!
            </p>
            <div className="credito-seguro-cards">
              <div className="credito-seguro-card">
                <img src="assets/emprestimo-garantia-carro/ic_bank_credit_red.svg" alt="" />
                <p className="credito-seguro-card-texto">
                  Você pode investir no seu próprio negócio
                </p>
              </div>
              <div className="credito-seguro-card">
                <img src="assets/emprestimo-garantia-carro/ic_home.svg" alt="" />
                <p className="credito-seguro-card-texto">Fazer aquela reforma na sua casa</p>
              </div>
              <div className="credito-seguro-card">
                <img src="assets/emprestimo-garantia-carro/ic_percent.svg" alt="" />
                <p className="credito-seguro-card-texto">
                  Trocar várias dívidas altas por uma única com taxas mais baixas
                </p>
              </div>
              <div className="credito-seguro-card">
                <img src="assets/emprestimo-garantia-carro/ic_travel.svg" alt="" />
                <p className="credito-seguro-card-texto">
                  Planejar a viagem dos sonhos para você e sua família
                </p>
              </div>
            </div>
            <WhiteButton
              href="https://emprestimosim.com.br/app/#/onboarding/signUp"
              target="_blank"
              className="credito-seguro-btn-simular"
            >
              Simular agora
            </WhiteButton>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroCreditoSeguro;
